/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('webNote', function() {
        return {
            scope: {
                note: '=',
                noteIndex: '='
            },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/note/note.view.html',
            controller: ["$scope", "NotesModel", "DocumentService", "NotesService", "$timeout", function($scope, NotesModel, DocumentService, NotesService, $timeout) {
                var scope = $scope;
                var loadCallback;
                // console.log('work')
                scope.navigate = function(note) {
                    // console.log(note, scope.noteObject, scope.noteObject.quotation.begin);
                    var str = angular.copy(scope.noteObject.quotation.begin || scope.note.mark.anchor);
                    var epubcfi = '#epubcfi';
                    var beginIndx = str.search(epubcfi);
                    var resSting = str.substr(beginIndx, str.length);
                    var cfi_position = resSting.match(/\/\d+/ig);
                    var charCfiPosition = resSting.match(/\:\d+/ig);
                    var concatArr = cfi_position.concat(charCfiPosition)
                    var repleseAll = concatArr.join().replace(/,/g, '');
                    var result = epubcfi + '(' + repleseAll + ')';
                    DocumentService.scrollDocumentToChapter(null, result);
                };

                scope.deleteNote = function() {
                    console.log('del', scope.noteObject);
                    NotesModel.removeNote(scope.noteObject.uuid, scope.noteObject);
                };

                scope.updateNoteText = function() {
                    NotesModel.updateNoteText(scope.noteObject).catch(function(data) {
                        //if error, return text back
                        scope.noteObject.note.text = scope.noteObject.previousText;
                    });
                };

                scope.editMode = {
                    status: false,
                    text: '',
                    enable: function() {
                        var target = angular.element('textarea.edit-note')[0];
                        var self = this;

                        this.text = scope.noteObject.note.text;
                        this.status = true;

                        $timeout(function() {
                            self.taChange({ target: target });
                            target.focus();
                            DocumentService.changeSpinnerState(true, true);
                        }, 50);
                    },
                    apply: function() {
                        scope.noteObject.previousText = scope.noteObject.note.text;
                        scope.noteObject.note.text = this.text;
                        this.status = false;
                        scope.updateNoteText();
                        DocumentService.changeSpinnerState(false, false);
                    },
                    cancel: function() {
                        this.status = false;
                        DocumentService.changeSpinnerState(false, false);
                    },
                    taChange: function(e) {
                        e.target.style.height = '44px';
                        e.target.style.height = (e.target.scrollHeight) + "px";
                        !!e.preventDefault && e.preventDefault();
                        !!e.stopPropagation && e.stopPropagation();
                    }
                };

                scope.setColor = function(newColor, e) {
                    e.stopPropagation();
                    e.preventDefault();
                    scope.editColor = false;
                    scope.noteObject.previousColor = scope.noteObject.color.value || 'yellow';
                    scope.noteObject.color.value = newColor;
                    NotesModel.updateNoteColor(scope.noteObject).then(function(data) {
                        if (!data || !data.uuid) {
                            throw 'Error while saving new color';
                        }
                    }).catch(function() {
                        scope.noteObject.color.value = scope.noteObject.previousColor;
                        NotesModel.updateNoteColor(scope.noteObject);
                    });
                };


                if (NotesModel.checkIf.isNoteLoaded(scope.noteIndex)) {
                    scope.noteObject = NotesService.getNote(scope.noteIndex);
                    // console.log(scope.noteObject, 'note obj');
                } else {
                    loadCallback = NotesModel.subscribe.onNoteLoaded(scope.noteIndex, function() {
                        NotesModel.unsubscribe.onNoteLoaded(scope.noteIndex, loadCallback);
                        scope.noteObject = NotesService.getNote(scope.noteIndex);
                        // console.log(scope.noteObject, 'note');
                    });
                }
            }]
        };
    })
    .directive('webHighlight', function() {
        return {
            scope: {
                highlightIndex: '=',
                notes: '='
            },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/note/note.higthlight.html',
            controller: ["$scope", "HighlightsService", "DocumentService", "DocumentModel", "HighlightsModel", "NotesModel", function($scope, HighlightsService, DocumentService, DocumentModel, HighlightsModel, NotesModel) {
                var scope = $scope;
                var loadCallback;
                scope.navigate = function() {

                    DocumentService.scrollDocumentToChapter(null, scope.note.quotation.begin);
                };
                // console.log(scope.highlightIndex);
                scope.removeHighlight = function(index) {
                    HighlightsModel.removeHighlight(scope.note.uuid, scope.note);
                    // scope.notes.splice(index, 1);
                };
                if (HighlightsModel.checkIf.isHighlightLoaded(scope.highlightIndex)) {
                    scope.note = HighlightsService.getHighlight(scope.highlightIndex);
                    // console.log(scope.note);
                } else {
                    loadCallback = HighlightsModel.subscribe.onHighlightLoaded(scope.highlightIndex, function() {
                        HighlightsModel.unsubscribe.onHighlightLoaded(scope.highlightIndex, loadCallback);
                        scope.note = HighlightsService.getHighlight(scope.highlightIndex);
                    });
                }
                // console.log('works fine', scope.noteObject);
            }]
        }
    });